import Component from '@cell/cell-core/component/component';
import './dropdown-trigger.scss';

class DropdownTrigger extends Component {
  constructor() {
    super();

    this.open = false;

    this.handleClick = this.handleClick.bind(this);
    this.handleDropdownContentClosed = this.handleDropdownContentClosed.bind(this);
  }

  componentDidMount() {
    this.on('click', this.handleClick);

    globalThis.on('dropdown-content.closed', this.handleDropdownContentClosed);
  }

  handleClick() {
    this.open = !this.open;

    this.setAttribute('aria-expanded', this.open);

    this.emit('toggle', {
      handle: this.parsedDataset.handle,
    });
  }

  handleDropdownContentClosed({ data }) {
    if (data.handle !== this.parsedDataset.handle) return;

    this.open = false;
    this.setAttribute('aria-expanded', this.open);
  }
}

customElements.define('dropdown-trigger', DropdownTrigger);
